module.exports = __webpack_public_path__ + "img/zebra.98072336.jpg";